import { IAprazamento } from "../../../pages/medicalRecord/components/careLines/RequestAppointmentModal";
import { GenericService } from "./Generic.service";

export class AppointmentService extends GenericService<any> {
  readonly URI: string = "Atendimento";

  constructor() {
    super();
    this.setUri(this.URI);
  }

  public async getPanelInfo(body: any) {
    return await super.postByResource(body, "Painel");
  }

  public async registerAppointment(body: any) {
    return await super.postByResource(body, "");
  }

  public async updateAppointment(body: any, atendimentoId: string) {
    return await super.putByResource(body, `${atendimentoId}`);
  }

  public async getAtendimentoList(body: any) {
    return await super.getByResource("AtendimentoSimplificado", body);
  }

  public async getAtendimentoDetail(atendimentoId: string) {
    return await super.getByResource(`AtendimentoDetalhado/${atendimentoId}`);
  }

  public async getDeveExibirAlta(pacienteId: string) {
    return await super.getByResource(`DeveExibirAlta/${pacienteId}`);
  }

  public async getEspecialidades() {
    return await super.getByResource("Especialidades", { PageSize: 5000 });
  }

  public async getAnos() {
    return await super.getByResource("Anos", { PageSize: 5000 });
  }

  public async getImprimiveis() {
    return await super.getByResource("Imprimiveis", { PageSize: 5000 });
  }

  public async getAtendimentoResumido(ano: any, pacienteId: any) {
    return await super.getByResource(`AtendimentoResumo?ano=${ano}&pacienteId=${pacienteId}`);
  }

  public async deleteAtendimentoById(atendimentoId: string) {
    return await super.deleteByResource(
      { id: atendimentoId },
      `${atendimentoId}`
    );
  }

  public async getGeneratePdfs(body: any, atendimentoId: string) {
    return await super.postByResourceHeadersPDF(
      body,
      `${atendimentoId}/Imprimiveis`
    );
  }

  public async getCIDByNameOrCode(query: string) {
    return await super.getByResource("CID", { Texto: query });
  }

  public async addNewAprazamento(body: IAprazamento) {
    return await super.postByResource(body, "Aprazamento");
  }

  public async getProblems(id: string) {
    return await super.getByPath(`Problemas/${id}`);
  }

  public async getPronturariosList(body: any) {
    return await super.getByResource("Prontuarios", body);
  }

  public async getLastAppointment(pessoaId: string) {
    return await super.getByResource(`UltimoClinicFrame/${pessoaId}`);
  }

  public async getPendingAppointments() {
    return await super.getByResource("VerificarAtendimentosPendentes");
  }
}
